export default __webpack_public_path__ + "static/media/graph-orange.0384ed38.svg";